import React, { useState } from 'react';

const VPNInstructionsModal = ({ isOpen, onClose }) => {
  const [selectedClient, setSelectedClient] = useState('hiddify');

  if (!isOpen) return null;

  const clients = {
    hiddify: {
      name: 'Hiddify',
      platforms: ['Android', 'iOS', 'Windows', 'macOS', 'Linux'],
      icon: '🔷',
      steps: [
        'Скачайте Hiddify из официального магазина приложений',
        'Откройте приложение и нажмите кнопку "+" в правом нижнем углу',
        'Выберите "Добавить из буфера обмена" или вставьте ссылку вручную',
        'Подписка автоматически добавится',
        'Нажмите на переключатель для подключения к VPN'
      ],
      download: 'https://hiddify.com'
    },
    v2rayng: {
      name: 'V2RayNG',
      platforms: ['Android'],
      icon: '📱',
      steps: [
        'Установите V2RayNG из Google Play',
        'Откройте приложение и нажмите на "+" в правом верхнем углу',
        'Выберите "Импортировать конфигурацию из буфера обмена"',
        'Подписка автоматически импортируется',
        'Нажмите на подключение и выберите "Подключиться"'
      ],
      download: 'https://play.google.com/store/apps/details?id=com.v2ray.ang'
    },
    shadowrocket: {
      name: 'Shadowrocket',
      platforms: ['iOS'],
      icon: '🚀',
      steps: [
        'Купите Shadowrocket в App Store ($2.99)',
        'Откройте приложение',
        'Нажмите на "+" в правом верхнем углу',
        'Выберите "Тип" → "Subscribe"',
        'Вставьте ссылку на подписку в поле URL',
        'Нажмите "Готово" и включите VPN'
      ],
      download: 'https://apps.apple.com/app/shadowrocket/id932747118'
    },
    nekoray: {
      name: 'NekoRay',
      platforms: ['Windows', 'Linux'],
      icon: '🐱',
      steps: [
        'Скачайте NekoRay с GitHub',
        'Распакуйте архив и запустите приложение',
        'Нажмите "Профиль" → "Новая группа"',
        'Выберите "Добавить из буфера" или вставьте ссылку',
        'Нажмите правой кнопкой на сервер → "Запустить"'
      ],
      download: 'https://github.com/MatsuriDayo/nekoray/releases'
    },
    streisand: {
      name: 'Streisand',
      platforms: ['iOS'],
      icon: '⭐',
      steps: [
        'Установите Streisand из App Store (бесплатно)',
        'Откройте приложение',
        'Нажмите "+" для добавления подписки',
        'Вставьте ссылку на подписку',
        'Выберите сервер и нажмите "Подключиться"'
      ],
      download: 'https://apps.apple.com/app/streisand/id6450534064'
    },
    happ: {
      name: 'Happ',
      platforms: ['iOS', 'Android'],
      icon: '😊',
      steps: [
        'Скачайте Happ из App Store или Google Play',
        'Откройте приложение',
        'Нажмите на значок "+" внизу экрана',
        'Выберите "Импорт из буфера обмена"',
        'Подписка добавится автоматически',
        'Активируйте VPN переключателем'
      ],
      download: 'https://happ.me'
    }
  };

  const client = clients[selectedClient];

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          {/* Заголовок */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-900 flex items-center">
              <svg className="w-7 h-7 mr-2 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Инструкции по настройке
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Выбор клиента */}
          <div className="mb-6">
            <h3 className="text-sm font-medium text-gray-700 mb-3">Выберите ваш VPN клиент:</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {Object.entries(clients).map(([key, c]) => (
                <button
                  key={key}
                  onClick={() => setSelectedClient(key)}
                  className={`p-4 rounded-lg border-2 transition-all text-left ${
                    selectedClient === key
                      ? 'border-primary-600 bg-primary-50'
                      : 'border-gray-200 hover:border-primary-300'
                  }`}
                >
                  <div className="text-2xl mb-2">{c.icon}</div>
                  <div className="font-semibold text-gray-900 text-sm">{c.name}</div>
                  <div className="text-xs text-gray-500 mt-1">
                    {c.platforms[0]}{c.platforms.length > 1 ? ` +${c.platforms.length - 1}` : ''}
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Инструкция для выбранного клиента */}
          <div className="bg-gray-50 rounded-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-xl font-bold text-gray-900 flex items-center">
                  <span className="text-3xl mr-3">{client.icon}</span>
                  {client.name}
                </h3>
                <div className="flex flex-wrap gap-2 mt-2">
                  {client.platforms.map(platform => (
                    <span key={platform} className="px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded">
                      {platform}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Шаги */}
            <div className="space-y-4 mb-6">
              {client.steps.map((step, index) => (
                <div key={index} className="flex items-start">
                  <div className="flex-shrink-0 w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                    {index + 1}
                  </div>
                  <p className="ml-4 text-gray-700 pt-1">{step}</p>
                </div>
              ))}
            </div>

            {/* Ссылка на скачивание */}
            <a
              href={client.download}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors font-medium"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Скачать {client.name}
            </a>
          </div>

          {/* Общая подсказка */}
          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex items-start">
              <svg className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <div>
                <p className="text-sm font-medium text-blue-900">Важно</p>
                <p className="text-sm text-blue-700 mt-1">
                  После добавления подписки приложение автоматически загрузит все доступные серверы. 
                  Вы можете выбрать любой сервер из списка для подключения.
                </p>
              </div>
            </div>
          </div>

          {/* Кнопка закрытия */}
          <div className="mt-6 flex justify-center">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg transition-colors font-medium"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VPNInstructionsModal;











